import React, { Fragment } from "react";
import { FormSpy } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import ActionsPopup from "../UI/ActionsPopup";
import actions_schema from "./actions_schema";
import AlertOFLC from "../../../global/containers/AlertOFLC";
import helper from "./helpers";
import PageError from "../UI/PageError";
import { fLabelResolver } from "../FormSummary/FieldArraySummary";
import countyExceptions from "../../../data/countyExceptions";

class FieldArrayGenerator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      edit_index: -1,
      prevailing_wage_question_value: undefined,
      current_soc_code: this.props.formApi.getState().values["b2_soc_code"],
    };
  }

  //TODO remove 9035 specific logic for this...and remove 9035 specific values from state above
  componentDidUpdate() {
    if (!this.state.edit) {
      let pwq =
        this.props.formApi.getState().values[
          "_section_f_f12_f13_f14_prevailing_wage_question"
        ];
      let soc = this.props.formApi.getState().values["b2_soc_code"];
      let clearValues = false;

      if (pwq != this.state.prevailing_wage_question_value) {
        this.setState({ prevailing_wage_question_value: pwq });
        clearValues = true;
      } else if (soc != this.state.current_soc_code) {
        this.setState({ current_soc_code: soc });
        clearValues = true;
      }

      if (clearValues) {
        this.props.formApi.change("_section_f_f11_prevailing_wage", undefined);
        this.props.formApi.change(
          "_section_f_f11a_prevailing_wage_per",
          undefined
        );
      }
    }
  }

  renderFieldArray = () => (
    <FieldArray
      name={this.props.section.machine_name}
      validate={this.props.validate}
    >
      {(props) => {
        return this.props.children;
      }}
    </FieldArray>
  );

  renderTableRow = (row, row_index) => {
    const {
      formApi,
      formValues,
      section: {
        machine_name: section_machine_name,
        fieldArray: {
          table: { value_machine_names },
        },
      },
    } = this.props;

    let table_row = [];

    value_machine_names.map((col, i) => {
      if (typeof col !== "object") {
        table_row = table_row.concat(<td key={i}>{row[col]}</td>);
      } else {
        let value;
        // todo: support multiple templates
        if (col.template === "wage_rate") {
          if (
            col.machine_names[1] &&
            row[col.machine_names[1]] !== undefined &&
            row[col.machine_names[1]] !== null
          ) {
            value = `$${row[col.machine_names[0]]} - $${
              row[col.machine_names[1]]
            } per ${row[col.machine_names[2]]}`;
          } else {
            value = `$${row[col.machine_names[0]]} per ${
              row[col.machine_names[2]]
            }`;
          }
        }
        table_row = table_row.concat(<td>{value}</td>);
      }
    });

    let action_functions = {
      edit: () => {
        this.setState({ edit: true, edit_index: row_index });

        let current_row = formValues[section_machine_name][row_index];
        if (current_row !== undefined) {
          Object.keys(current_row).map((name) => {
            if (current_row[name] !== undefined) {
              formApi.change(
                helper.modifyMachineName(name, section_machine_name),
                current_row[name]
              );
            }
            return "";
          });

          this.props.setFieldArrayExtraInfo((prev) => ({
            ...prev,
            rowDisabled:
              current_row?.f12_f13_f14_prevailing_wage_question ===
              "f13_is_oes_prevailing_wage",
          }));

          helper.scrollToTop();
        }
      },
      delete: () => {
        formApi.mutators.remove(section_machine_name, row_index);
      },
    };

    let action_column = (
      <td>
        <ActionsPopup
          schema={actions_schema(action_functions)}
          id={row_index}
        />
      </td>
    );
    table_row = table_row.concat(action_column);
    return table_row;
  };

  renderTable = () => {
    const {
      section: {
        machine_name,
        fieldArray: { table, noun },
      },
      formValues,
    } = this.props;

    let rows = formValues[machine_name];

    if (table && rows && rows.length > 0) {
      return (
        <table className="usa-table">
          <thead>
            <tr>
              {table.headers.map((header, i) => {
                return <th key={i}>{header}</th>;
              })}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>{this.renderTableRow(row, i)}</tr>
            ))}
          </tbody>
        </table>
      );
    } else {
      return (
        <Fragment>
          <table className="usa-table">
            <thead>
              <tr>
                {table.headers.map((header, i) => {
                  return <th key={i}>{header}</th>;
                })}
                <th>Actions</th>
              </tr>
            </thead>
          </table>
          <div style={{ padding: "20px" }}>
            No entries for {noun.toLowerCase()}
          </div>
        </Fragment>
      );
    }
  };

  clearNecessaryValues = () => {
    const {
      formApi,
      formValues,
      section: {
        fieldArray: { clear_schema },
      },
    } = this.props;
    clear_schema.map((o) => {
      if (formValues[o.when] === o.is) {
        o.clear.map((field_to_clear) => {
          formApi.change(field_to_clear, undefined);
        });
      }
    });
  };

  getRequiredFields = () => {
    const {
      formValues,
      section: {
        fieldArray: { required_schema },
      },
    } = this.props;

    let required_errors = {};

    required_schema.map((item) => {
      if (typeof item === "string") {
        if (
          formValues[item] === "" ||
          formValues[item] === undefined ||
          formValues[item] === "- Select -"
        ) {
          required_errors[item] = "This field is required";
          // return false;
        }
      } else {
        // 3 part object:
        // require: field to require if when-is condition is true
        // when: field to look at
        // is: value to look at

        if (
          formValues[item.when] !== undefined &&
          item.isNot !== undefined &&
          formValues[item.when] !== item.isNot
        ) {
          if (
            formValues[item.require] === "" ||
            formValues[item.require] === undefined ||
            formValues[item.require] === "- Select -"
          ) {
            required_errors[item.require] = "This field is required";
          }
        } else if (
          formValues[item.when] !== undefined &&
          formValues[item.when] === item.is
        ) {
          if (
            item.require &&
            item.required !== undefined &&
            item.require.indexOf("county") > -1
          ) {
            if (
              (formValues[item.require].value === "" ||
                formValues[item.require].value === undefined ||
                formValues[item.require].value === "- Select -") &&
              countyExceptions.indexOf(formValues[item.when]) === -1
            ) {
              required_errors[item.require] = "This field is required";
            }
          } else if (
            item.require &&
            item.require !== undefined &&
            (formValues[item.require] === "" ||
              formValues[item.require] === undefined ||
              formValues[item.require] === "- Select -")
          ) {
            required_errors[item.require] = "This field is required";
          }
        }
      }
    });
    return required_errors;
  };

  /**
   * returns bool: true if all required fields are filled, false otherwise
   */
  requiredFieldsFilled = () => {
    const {
      formValues,
      section: {
        fieldArray: { required_schema },
      },
    } = this.props;

    for (let i = 0; i < required_schema.length; i++) {
      const item = required_schema[i];
      if (typeof item === "string") {
        if (
          formValues[item] === "" ||
          formValues[item] === undefined ||
          formValues[item] === "- Select -"
        ) {
          return false;
        }
      } else {
        // 3 part object:
        // require: field to require if when-is condition is true
        // when: field to look at
        // is: value to look at
        if (
          formValues[item.when] !== undefined &&
          formValues[item.when] === item.is
        ) {
          if (
            item.require &&
            item.required !== undefined &&
            item.require.indexOf("county") > -1
          ) {
            if (
              formValues[item.require].value === "" ||
              formValues[item.require].value === undefined
            ) {
              return false;
            }
          } else if (
            item.require &&
            item.require !== undefined &&
            (formValues[item.require] === "" ||
              formValues[item.require] === undefined)
          ) {
            return false;
          }
        }
      }
    }
    return true;
  };

  render() {
    const {
      section: {
        label,
        machine_name: section_machine_name,
        fieldArray: { count_label, limit, limit_message, info, noun },
      },
      formApi,
      formValues,
    } = this.props;

    let machine_names = Object.keys(formValues).filter(
      (machine_name) =>
        machine_name.indexOf(section_machine_name) > -1 &&
        machine_name !== section_machine_name
    );

    const clearForm = () => {
      machine_names.map((name) => {
        formApi.change(name, "");
        return "";
      });
    };

    const currentValuesEmpty = (current_values) => {
      let empty = true;
      Object.keys(current_values).map((k) => {
        if (current_values[k] !== "") {
          empty = false;
          return empty;
        }
      });
      return empty;
    };

    const current_values = {};
    machine_names.map((machine_name) => {
      current_values[
        helper.cleanMachineName(machine_name, section_machine_name)
      ] = formValues[machine_name];
      return "";
    });

    const count =
      (formValues[section_machine_name] &&
        Object.keys(formValues[section_machine_name]).length) ||
      0;
    const limit_reached = count === limit;
    const required_fields_filled = this.requiredFieldsFilled();
    const required_errors = this.getRequiredFields();
    this.clearNecessaryValues();

    return (
      <Fragment>
        <div>
          {label && <label className={`usa-label`}>{label}</label>}
          {this.renderFieldArray()}
        </div>

        <FormSpy subscription={{ errors: true }}>
          {({ errors }) => {
            let field_array_errors = {};
            Object.keys(errors).map((machine_name) => {
              if (
                machine_name.indexOf(section_machine_name) > -1 &&
                machine_name !== section_machine_name
              ) {
                field_array_errors[
                  helper.cleanMachineName(machine_name, section_machine_name)
                ] = errors[machine_name];
              }
              return "";
            });
            const errors_exist = Object.keys(field_array_errors).length > 0;
            const current_values_empty = currentValuesEmpty(current_values);
            const form_untouched =
              Object.keys(current_values).length === 0 || current_values_empty;

            const renderErrors = (errors) => {
              return Object.keys(errors).map((machine_name) => {
                let label, message;
                if (machine_name.indexOf(section_machine_name) > -1) {
                  let mn = machine_name.replace(
                    `_${section_machine_name}_`,
                    ""
                  );
                  label = fLabelResolver(mn);
                } else {
                  label = fLabelResolver(machine_name);
                }

                message = errors[machine_name];
                return (
                  <PageError>
                    <strong>{label}</strong>: {message}
                  </PageError>
                );
              });
            };

            return (
              <Fragment>
                {!form_untouched && renderErrors(field_array_errors)}
                {!form_untouched && renderErrors(required_errors)}
                <div className="table-btn-group">
                  <button
                    type="button"
                    className="usa-button"
                    disabled={
                      !required_fields_filled ||
                      errors_exist ||
                      form_untouched ||
                      limit_reached
                    }
                    onClick={() => {
                      if (!this.state.edit) {
                        formApi.mutators.push(
                          section_machine_name,
                          current_values
                        );
                      } else {
                        formApi.mutators.update(
                          section_machine_name,
                          this.state.edit_index,
                          current_values
                        );
                        this.setState({ edit: false, edit_index: -1 });
                      }
                      if (formApi.getState().values["OES_area_based"]) {
                        formApi.change("OES_area_based", undefined);
                      }

                      this.props.setFieldArrayExtraInfo((prev) => ({
                        ...prev,
                        rowDisabled: false,
                        isInitialStateValue: true,
                      }));

                      clearForm();
                    }}
                  >
                    <span>
                      {!this.state.edit ? `Add ${noun}` : `Update ${noun}`}
                    </span>
                  </button>
                  <button
                    type="button"
                    className="usa-button usa-button--outline"
                    onClick={clearForm}
                  >
                    Clear Form
                  </button>
                </div>
              </Fragment>
            );
          }}
        </FormSpy>

        <h3>{`${count} ${count_label}`}</h3>

        <AlertOFLC type={"grey"}>{info}</AlertOFLC>

        {limit_reached && <AlertOFLC type={"grey"}>{limit_message}</AlertOFLC>}
        {!required_fields_filled && (
          <AlertOFLC
            type={"grey"}
          >{`Please fill out all required fields ( * )`}</AlertOFLC>
        )}
        {this.renderTable()}
      </Fragment>
    );
  }
}

export default FieldArrayGenerator;
